export { FaqRouter as FaqApp } from "./faq/FaqRouter";
